module.exports = __webpack_public_path__ + "img/dotes_9x10.500efb23.svg";